import { lmsReportType } from "../constants/lmsReportType";
import { API_STATUS } from "../../constant/constant";

const initialState = {
  flow: "lmsReport",
  isError: false,
  isLoading: false,
};

export const getLmsReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case lmsReportType.GET_LMS_REPORT_PENDING:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: true,
      };
    case lmsReportType.GET_LMS_REPORT_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        ...action.data,
        isError: false,
        isLoading: false,
      };
    case lmsReportType.GET_LMS_REPORT_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: true,
        isLoading: false,
        error: { ...action.error },
      };
    default:
      return state;
  }
};

export const getLmsReportCourseReducer = (state = initialState, action) => {
  switch (action.type) {
    case lmsReportType.GET_LMS_REPORT_COURSE_PENDING:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: true,
      };
    case lmsReportType.GET_LMS_REPORT_COURSE_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        ...action.data,
        isError: false,
        isLoading: false,
      };
    case lmsReportType.GET_LMS_REPORT_COURSE_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: true,
        isLoading: false,
        error: { ...action.error },
      };
    default:
      return state;
  }
};

export const getLmsReportLessonReducer = (state = initialState, action) => {
  switch (action.type) {
    case lmsReportType.GET_LMS_REPORT_LESSON_PENDING:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: true,
      };
    case lmsReportType.GET_LMS_REPORT_LESSON_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        ...action.data,
        isError: false,
        isLoading: false,
      };
    case lmsReportType.GET_LMS_REPORT_LESSON_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: true,
        isLoading: false,
        error: { ...action.error },
      };
    default:
      return state;
  }
};

export const getLmsDashboardReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case lmsReportType.GET_LMS_DASHBOARD_REPORT_PENDING:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: true,
      };
    case lmsReportType.GET_LMS_DASHBOARD_REPORT_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        ...action.data,
        isError: false,
        isLoading: false,
      };
    case lmsReportType.GET_LMS_DASHBOARD_REPORT_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: true,
        isLoading: false,
        error: { ...action.error },
      };
    default:
      return state;
  }
};

export const getLmsDashboardReportDetailsReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case lmsReportType.GET_LMS_DASHBOARD_REPORT_DETAILS_PENDING:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: true,
      };
    case lmsReportType.GET_LMS_DASHBOARD_REPORT_DETAILS_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        ...action.data,
        isError: false,
        isLoading: false,
      };

    case lmsReportType.GET_LMSREPORT_LIST_EMAIL_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        isError: false,
        isLoading: false,
      };
    case lmsReportType.GET_LMS_DASHBOARD_REPORT_DETAILS_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: true,
        isLoading: false,
        error: { ...action.error },
      };
    case lmsReportType.CLEAR_LMS_DASHBOARD_REPORT_DETAILS:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: false,
        data: "",
      };
    default:
      return state;
  }
};

// completed course lesson safety meeting
export const getLmsDashboardCourseLessonSafetyMeetingCompeletedReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_PENDING:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: true,
      };
    case lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        ...action.data,
        isError: false,
        isLoading: false,
      };
    case lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_SUCCESS_EMAIL:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        isError: false,
        isLoading: false,
      };

    case lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: true,
        isLoading: false,
        error: { ...action.error },
      };

    case lmsReportType.CLEAR_LMS_DASHBOARD_REPORT_LESSON_COURSE_SAFETY_COMPLETED:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: false,
        data: "",
      };

    default:
      return state;
  }
};

// In completed course lesson safety meeting
export const getLmsDashboardCourseLessonSafetyMeetingInCompeletedReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_PENDING:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: true,
      };
    case lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        ...action.data,
        isError: false,
        isLoading: false,
      };
    case lmsReportType.GET_COURSELECTION_MAIL_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        isError: false,
        isLoading: false,
      };
    case lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: true,
        isLoading: false,
        error: { ...action.error },
      };
    case lmsReportType.CLEAR_LMS_DASHBOARD_REPORT_LESSON_COURSE_SAFETY_INCOMPLETED:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: false,
        data: "",
      };
    default:
      return state;
  }
};
export const getLmsScormCourseReportReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case lmsReportType.GET_LMS_SCORMLIST_REPORT_PENDING:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: true,
      };
    case lmsReportType.GET_LMS_SCORMLIST_REPORT_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        ...action.data,
        isError: false,
        isLoading: false,
      };
    case lmsReportType.GET_LMS_SCORMLIST_REPORT_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: true,
        isLoading: false,
        error: { ...action.error },
      };
    case lmsReportType.CLEAR_LMS_DASHBOARD_GET_LMS_SCORMLIST_REPORT:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: false,
        isLoading: false,
        data: "",
      };
    case lmsReportType.GET_LMS_SCORM_REPORT_LIST_EMAIL_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        isError: false,
        isLoading: false,
      };
    default:
      return state;
  }
};
